
import { Box, useTheme } from "@mui/material";      
import { DataGrid,Toolbar, ToolbarButton, ExportCsv, ExportPrint,QuickFilter, QuickFilterControl } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { mockDataContacts } from "../../data/mockData";
import Header from "../../components/Header";



// const CustomToolbar = () => {
//     return (
//         <Toolbar sx={{ backgroundColor: "#1f2a40", px: 2, py: 1,gap: 1, }}>
//             {/* بحث سهل */}
//             <QuickFilter>
//                 <QuickFilterControl sx={{ mr: 2, input: { color: "#fff" }, fieldset: { borderColor: "#555" }, }} />
//             </QuickFilter>

            
//             {/* زر تصدير CSV */}
//             <ToolbarButton
//                 startIcon={<ExportCsv />}
//                 sx={{color:"#fff", "&:hover": {backgroundColor: "#6870fa",}, }}
//                 label="CSV"
//                 onClick={() => {}}
//             >
//                     <ExportCsv />
//             </ToolbarButton>

//             {/* زر تصدير طباعة */}
//             <ToolbarButton
//                 startIcon={<ExportPrint />}
//                 sx={{
//                 color: "#fff",
//                 "&:hover": {
//                     backgroundColor: "#4cceac",
//                 },
//                 }}
//             >
//                 Print
//             </ToolbarButton>
    
//         </Toolbar>
//     );
// }

const Contacts = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const columns = [   { field: "id", headerName: "ID", flex: 0.5},
                        { field: "registrarId", headerName: "Registrar ID"},
                        { field: "name", headerName: "Name", flex: 0.5, cellClassName: "name-column--cell"},
                        { field: "age", headerName: "Age", type: "number", headerAlign: "left", align: "left"},
                        { field: "phone", headerName: "Phone Number", flex: 0.5},
                        { field: "email", headerName: "Email", flex: 0.5},
                        { field: "address", headerName: "Address",flex: 1},
                        { field: "city", headerName: "City", flex: 1},
                        { field: "zipCode", headerName: "Zip Code", flex: 1},
                    ]
    
    return (
        <Box m="20px">
            <Header title="CONTACTS" subtitle="List of Contacts" /> 
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root":{
                        border: "none"
                    },
                    "& .MuiDataGrid-cell":{
                        borderBottom: "none"
                    },
                    "& .name-column--cell":{
                        color: colors.greenAccent[300]
                    },
                    "& .MuiDataGrid-columnHeaders":{
                        backgroundColor: colors.blueAccent[200],
                        borderBottom: "none"
                    },
                    "& .MuiDataGrid-virtualScroller":{
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                }}
            >
                <DataGrid 
                    rows={mockDataContacts}
                    columns={columns}
                    //slots={{ toolbar: CustomToolbar }}
                    showToolbar
                />
            </Box>
        </Box>
    );
};

export default Contacts;